export default __webpack_public_path__ + "static/media/640_store05-en-web.60c089e3.png";